export class BatchWindow {
  private _value: number

  constructor (value: number) {
    if (value < 1) {
      throw new TypeError('Batch Window should be at least 1')
    }
    this._value = Math.trunc(value)
  }

  window (): number {
    return this._value
  }
}
